import React, { useState } from "react";
import { message } from "antd";
import Button from "react-bootstrap/Button";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../assets/scss/pages/auth.scss";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../components/widgets";
import { resendVerifyEmail } from "../../actions/user";

const RecoveryPassword: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [apiMessage, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const response = await resendVerifyEmail(email);
      if (response.status) {
        setMessage("Password reset email sent successfully.");
        message.success(`Email sent to ${email}. Please check your inbox`, 3);
        setEmail("");
      } else if (!response.status && response.message) {
        message.error(response.message, 3);
        setMessage(response.message);
      } else {
        setMessage("An error occurred. Please try again.");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="page recover-page page-auth auth-login">
      <div className="d-flex justify-content-center mt-5 items-center h-full w-full">
        <div
          className="d-flex align-items-center flex-column"
          style={{ width: "100px" }}
        >
          <div className="focus" onClick={() => navigate("/")}>
            <svg
              width="81"
              height="81"
              viewBox="0 0 81 81"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="40.6836" cy="40.4211" r="40" fill="#07294C" />
              <path
                d="M40.6838 3.62109C20.388 3.62109 3.88379 20.1253 3.88379 40.4211C3.88379 60.7169 20.388 77.2211 40.6838 77.2211C60.9795 77.2211 77.4838 60.7169 77.4838 40.4211C77.4838 20.1253 61.0911 3.62109 40.6838 3.62109ZM20.2765 32.169C21.8377 35.5144 25.2947 37.8562 29.1977 37.8562C34.662 37.8562 39.1226 33.3956 39.1226 27.9314C39.1226 24.2514 37.1153 21.0175 33.9929 19.3447C36.1117 18.6756 38.342 18.3411 40.6838 18.3411C52.8389 18.3411 62.7638 28.2659 62.7638 40.4211C62.7638 52.5762 52.8389 62.5011 40.6838 62.5011C28.5286 62.5011 18.6038 52.5762 18.6038 40.4211C18.6038 37.5217 19.1614 34.7338 20.2765 32.169Z"
                fill="#DDE9F4"
              />
            </svg>
          </div>

          <Form noValidate className="mt-3" onSubmit={handleSubmit}>
            <Form.Label className="cation d-flex justify-content-center mb-5">
              <h1>Reset Password</h1>
            </Form.Label>
            <Form.Group className="mb-4">
              <Form.Control
                required
                type="email"
                autoComplete="off"
                placeholder="E-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <Form.Control.Feedback type="invalid">
                Please fill out e-mail.
              </Form.Control.Feedback>
            </Form.Group>

            <div className="d-flex flex-column">
              <div className="d-flex justify-content-center">
                <Button
                  className="w-100 mb-3 login d-flex justify-content-center"
                  type="submit"
                  disabled={isLoading}
                >
                  {isLoading ? <Icon name="loading" /> : "Send"}
                </Button>
              </div>
              {apiMessage && <p className="text-center">{apiMessage}</p>}
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default RecoveryPassword;
